import Vue from 'vue'
import Notifications from 'vue-notification'
import AppNotifications from '~/services/Notifications/AppNotifications'

export default function ({ app }, inject) {
  Vue.use(Notifications)

  inject('notification', AppNotifications)
}
